module.exports = __webpack_public_path__ + "img/thumb.0df693ab.png";